export default __webpack_public_path__ + "static/media/geography.0de32c4f.svg";